<template>
    <div>
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">Method Details</p> 
            </div>
        </div>

        <view-method-feature :currentMethod="currentMethod"></view-method-feature>

        <div class="tile is-child">
            <!-- Action buttons -->
            <span class="is-pulled-right" style="margin-top:20px">
                <a v-if="currentMethod.status != 'LOCKED'" class="button is-large is-primary" v-on:click="editMethod(currentMethod)">
                    <span>Edit</span>
                </a>
                <span style="margin-left:20px"></span>
                <a class="button is-large" @click="$router.go(-1)">
                    <span>Back</span>
                </a>
            </span>
        </div>
    </div>
</template>


<script>
import ViewMethodFeature from './ViewMethodFeature'

var moment = require('moment');
export default {
    name: "ViewMethodComponent",
    props: ["currentMethod"],
    components: {
        ViewMethodFeature
    },
    data: function() {
        return {
            moment:moment,
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false
        }
    },
    methods : {
        editMethod: function (currentMethod) {
            console.log("edit btn in view clicked for: ", currentMethod.name)
            this.$emit("editMethod", currentMethod);
        },
        back: function() {
            this.$emit("back");
        },
        downloadMethodFile: function(currentMethod){
            // console.log("currentMethod.method_file", currentMethod.method_file)
            this.$emit("downloadMethodFile", currentMethod.method_file)            
        },
        accordionAction: function(id) {
            var accordionButton = document.getElementById(id)
            var contentOfAccordion = document.getElementById(id).nextSibling
            // console.log("x.style.display", x) is-primary 
            if (contentOfAccordion.style.display == "block") {
                contentOfAccordion.style.display = "none"
                accordionButton.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            } else if(contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            }

            // accordionButton class
            var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
            console.log("ohters...", otherAccordions)    
            otherAccordions.forEach(function(otherAccordionButton){
                if(accordionButton != otherAccordionButton){
                    var content = otherAccordionButton.nextSibling
                    content.style.display = "none"
                    otherAccordionButton.classList.remove("is-primary");
                }
                
            })

        }
    }
}
</script>

<style scoped>
.contentOfAccordion{
    display: none;
}
</style>